/**
 * Internal-only route at /og/token-intelligence-suite — pixel-perfect 1200×630
 * Open Graph card. Renderer screenshots this once and saves the PNG to
 * /public/og/token-intelligence-suite.png, which is served as a static asset
 * referenced from <SEOHead og:image>.
 *
 * DO NOT add this to the public nav. This URL exists for screenshot capture only.
 */
import React from 'react';

const OgTokenIntelligenceSuite = () => {
  return (
    <div style={{
      width: 1200, height: 630, background: '#020617',
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      color: '#f1f5f9', overflow: 'hidden', position: 'relative',
      display: 'flex', flexDirection: 'column', padding: '64px',
    }}>
      {/* Background radial accents */}
      <div style={{
        position: 'absolute', top: -180, left: -120,
        width: 600, height: 600, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(16,185,129,0.18) 0%, rgba(16,185,129,0) 60%)',
        filter: 'blur(40px)',
      }} />
      <div style={{
        position: 'absolute', bottom: -200, right: -160,
        width: 700, height: 700, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(34,211,238,0.12) 0%, rgba(34,211,238,0) 60%)',
        filter: 'blur(50px)',
      }} />

      {/* TOP BAR */}
      <div style={{
        position: 'relative', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10,
            background: 'linear-gradient(135deg, #10b981, #06b6d4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, color: '#020617', fontSize: 18,
          }}>C</div>
          <span style={{
            fontSize: 18, fontWeight: 600, letterSpacing: 0.5,
            color: '#f8fafc',
          }}>CARTIE<span className="text-emerald-400">AI</span></span>
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '6px 14px', borderRadius: 999,
          background: 'rgba(16,185,129,0.12)',
          border: '1px solid rgba(52,211,153,0.4)',
        }}>
          <span style={{
            width: 8, height: 8, borderRadius: '50%',
            background: '#34d399',
            boxShadow: '0 0 14px rgba(52,211,153,0.8)',
          }} />
          <span style={{
            fontSize: 12, fontWeight: 700, letterSpacing: 2.5,
            color: '#a7f3d0', textTransform: 'uppercase',
          }}>10 / 10 Live</span>
        </div>
      </div>

      {/* HEADLINE */}
      <div style={{
        position: 'relative', marginTop: 56, flex: 1,
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
      }}>
        <div style={{
          fontSize: 13, fontWeight: 700, letterSpacing: 4,
          color: '#34d399', textTransform: 'uppercase', marginBottom: 16,
        }}>Token Intelligence Suite</div>
        <h1 style={{
          fontSize: 76, lineHeight: 1.02, fontWeight: 800,
          letterSpacing: -1.5, margin: 0, color: '#f8fafc',
        }}>
          Enterprise token<br />
          control.<br />
          <span style={{
            background: 'linear-gradient(90deg, #6ee7b7 0%, #67e8f9 100%)',
            WebkitBackgroundClip: 'text', backgroundClip: 'text',
            WebkitTextFillColor: 'transparent', color: 'transparent',
          }}>Stop AI budget bleed instantly.</span>
        </h1>
      </div>

      {/* FEATURE STRIP */}
      <div style={{
        position: 'relative', display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap',
      }}>
        {[
          'Token Leak Detector',
          'Multi-Model Router',
          'Cache-Miss Detective',
          'Context Optimizer',
          'Drift Alerter',
          'Retry Audit',
        ].map((label, i) => (
          <span key={i} style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '8px 14px', borderRadius: 8,
            background: 'rgba(15,23,42,0.6)',
            border: '1px solid rgba(255,255,255,0.06)',
            fontSize: 14, fontWeight: 500, color: '#cbd5e1',
          }}>
            <span style={{
              width: 6, height: 6, borderRadius: '50%', background: '#34d399',
            }} />
            {label}
          </span>
        ))}
      </div>

      {/* BOTTOM URL BAR */}
      <div style={{
        position: 'relative', marginTop: 32, display: 'flex',
        alignItems: 'center', justifyContent: 'space-between',
        paddingTop: 20, borderTop: '1px solid rgba(255,255,255,0.06)',
      }}>
        <div style={{ fontSize: 18, color: '#94a3b8', letterSpacing: 0.3 }}>
          cartieai.com/<span style={{ color: '#6ee7b7', fontWeight: 600 }}>token-intelligence-suite</span>
        </div>
        <div style={{ fontSize: 14, color: '#64748b', letterSpacing: 0.5 }}>
          2 free tools · no signup · outcome pricing
        </div>
      </div>
    </div>
  );
};

export default OgTokenIntelligenceSuite;
